import { Link } from "react-router-dom";
import useSEO from "@/lib/useSEO";

export default function PaymentCancel() {
  useSEO("Payment Cancelled | Fleece The Regime", "Checkout cancelled — nothing was charged.", true);
  return (
    <main data-testid="payment-cancel-page" className="pt-16 min-h-screen flex items-center">
      <div className="px-6 sm:px-12 lg:px-20 py-24 max-w-4xl">
        <p className="font-mono text-xs font-bold uppercase tracking-[0.3em] text-primary mb-6">Payment cancelled</p>
        <h1 className="font-display uppercase text-6xl sm:text-7xl leading-[0.85] tracking-tighter">
          Cold feet?<br />It happens.
        </h1>
        <p className="mt-8 max-w-md font-mono text-sm leading-relaxed text-black/70">
          Nothing was charged. Your cart is still warm whenever you're ready.
        </p>
        <Link
          to="/checkout"
          data-testid="payment-cancel-checkout-link"
          className="mt-10 inline-block border-2 border-black bg-primary px-8 py-4 font-display uppercase text-xl text-white shadow-hard btn-press hover:bg-black"
        >
          Back to checkout
        </Link>
      </div>
    </main>
  );
}
